import BoardingSchoolPositionRequirements from './BoardingSchoolPositionRequirements.component';

export default BoardingSchoolPositionRequirements;